import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import SelectableRecordTable from 'components/selectable_record_table/selectable_record_table';
import AssignmentRow from './assignment_row';

export class AssignmentsTable extends React.Component {
  static propTypes = {
    assignments: PropTypes.array.isRequired
  };

  render() {
    return (
      <SelectableRecordTable columnHeaders={this.renderColunnHeaders()} hasSelectColumn={false}>
        {this.renderAssignments()}
      </SelectableRecordTable>
    );
  }

  renderColunnHeaders() {
    return (
      <React.Fragment>
        <th />
        <th>Status</th>
        <th>Assignment Title</th>
        <th>Assignment Type</th>
        <th>Property Type</th>
        <th>Desired Location</th>
        <th>Brokers</th>
      </React.Fragment>
    );
  }

  renderAssignments() {
    return this.props.assignments.map(assignment => (
      <AssignmentRow assignment={assignment} key={assignment.id} />
    ));
  }
}

const mapStateToProps = state => ({
  assignments: state.search.assignments
});

export default connect(mapStateToProps)(AssignmentsTable);
